import { cva } from 'class-variance-authority'
import clsx from 'clsx'
import React from 'react'

const cardCVA = cva('si-card', {
    variants: {
        orientation: {
            horizontal: "si-card--horizontal",
            vertical: "si-card--vertical"
        },
    },
    defaultVariants: {
        orientation: "horizontal"
    }
})

const Card = ({ orientation, classes, children }) => {
    return (
        <div className={clsx(cardCVA({ orientation }), classes)}>
            {children}
        </div>
    )
}

export { Card }